import { IStyle } from '@fluentui/react';

export interface IAreaChartStyles {
  root: IStyle;
}

export interface IAreaChartClassNames {
  root: string;
}

export const areaChartStylesDefault: Partial<IAreaChartStyles> = {
  root: {
    height: '100%',
  },
};
